// Billing step 2: for accounts on the new billing system the API sends `paidThrough` with the subscription status
// (src/services/paid-through.js). It decides the payment banner on its own: overdue = warning with the deadline,
// paused = viewing paused until they pay. Legacy accounts get no `paidThrough` and keep today's banner logic.

export function bannerFromPaidThrough(paidThrough) {
  if (!paidThrough || paidThrough.known !== true) return null;
  return {
    hasIssue: Boolean(paidThrough.overdue || paidThrough.paused),
    pastGrace: Boolean(paidThrough.paused),
    deadline: paidThrough.paidThrough || null,
    canceled: Boolean(paidThrough.canceled)
  };
}

export function paidThroughMessage(state, formattedDeadline) {
  if (!state) return null;
  if (state.pastGrace) {
    return state.canceled
      ? 'Your subscription has ended. Start it again to see your data; nothing has been lost.'
      : 'Dashboard access is paused until a payment goes through. Your data is still being recorded.';
  }
  return `Your last payment didn't go through. Update your card by ${formattedDeadline || 'the deadline'} to keep dashboard access.`;
}
